export default "__VITE_PUBLIC_ASSET__1815de26__"